<template>
    <div id="catalog-categories">
        <div class="title-4 mb-24 d-none d-xl-block">Каталог</div>

        <div class="mb-24 d-flex d-xl-none align-items-center justify-content-between">
            <div class="title-4 mb-0">Категории</div>
            <div @click="closeFilter()" class="d-block d-xl-none pr-4"><img src="/svg/close.svg" alt=""></div>
        </div>


        <div class="catalog-categories__collapse" v-if="categories">

            <catalog-category-card v-for="(item, i) in categories" :key="i" :category="item"></catalog-category-card>
<!--            <div class="catalog-categories__collapse-item"-->
<!--                 :class="{'active': this.$route.path.includes('/sale') }">-->

<!--                <div class="h6" @click="getProductSale()">Продажа</div>-->
<!--            </div>-->

            <div class="catalog-categories__collapse-item"
                 :class="{'active': this.$route.path.includes('/discount') }">

                <div class="h6" @click="getProductDiscount()">Акционные товары</div>
            </div>
        </div>
    </div>
</template>

<script>
    import filter from '../../services/filter';

    export default {
        data() {
            return {
                subcategory: null,

                filter: filter,
            }
        },

        mounted() {
            if(this.$route.name.includes('account')) this.filter.state.account = true;
            else this.filter.state.account = false
        },

        computed: {
            categories() {
                return this.$store.getters.getLeftCategories;
            }
        },

        methods: {
            closeFilter() {
                this.$emit('close_categories', true);
            },
            getProductSale() {
                let url = '/sale';
                if (this.$route.path !== url) {
                    this.$router.push({path: url});
                }
            },
            getProductDiscount() {
                let url = '/discount';
                if (this.$route.path !== url) {
                    this.$router.push({path: url});
                }
            }

        }

    }
</script>
